import TripLink from "./TripLink";

export default TripLink;
